import {ProductCreateDto, ProductDto, ProductUpdateDto} from "../../../api";
import {useEffect, useState} from "react";
import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";
import {Select} from "antd";

export default function ProductSelectModalForm(props: ProductsSelectModalFormProps) {

    const [productNames, setProductNames] = useState<{ label: string, value: string }[]>();

    const refreshOptionsList = async () => {
        setProductNames(props.options?.map(p => {
            return {
                label: p.name!,
                value: p.id!.toString()
            }
        }));
    }

    useEffect(() => {
        refreshOptionsList()
    }, [props.options])


    const formItems: CrudFormItemProps[] = [
        {
            name: nameof<ProductCreateDto>("id"),
            label: "Nazwa",
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ],
            children: <Select
                style={{width: "100%"}}
                showSearch
                placeholder="Wybierz produkt..."
                options={productNames}
            />
        },
    ];


    return <CrudFormModal
        formItems={formItems}
        onSubmit={props.onSubmit}
        forceRender={true}
        destroyOnClose={true}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={props.saveButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
        modalCancelText={"Anuluj"}
        width={800}
    />;
}

interface ProductsSelectModalFormProps {
    initialValues?: ProductDto[] | ProductUpdateDto[],
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: ProductCreateDto | ProductUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
    options?: ProductDto[] | null,
}
